import React, { useState, useEffect } from 'react';
// material
import { Table, Button, TableRow, TableBody, TableCell, TextField, Container, TableContainer, Modal, Box, Grid } from '@mui/material';
// components
import Page from 'src/components/Page';
import Scrollbar from 'src/components/Scrollbar';
import { UserListHead } from 'src/sections/@dashboard/user';
import axios from 'axios';
import { apiHeader } from 'src/redux/actions/ApiHeader';
import { baseUrlPostGres } from 'src/redux/constant';
import { toast } from 'react-toastify';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import { Delete, Edit } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { LogoutAction } from 'src/redux/actions/AuthAction'
import { CKEditor } from 'ckeditor4-react';


import ReactQuill from 'react-quill';
import "react-quill/dist/quill.snow.css";

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

const TABLE_HEAD = [
    { id: 'c_no', label: 'Sr no.', alignRight: false },
    { id: 'c_title', label: 'Title', alignRight: false },
    { id: 'c_des', label: 'Description', alignRight: false },
    { id: 'c_alt', label: 'Alt Tag', alignRight: false },
    { id: 'c_actino', label: 'Action', alignRight: false },
];


const POPUP_TABLE_HEAD = [
    { id: 'c_no', label: 'Sr no.', alignRight: false },
    { id: 'c_title_new', label: 'Title', alignRight: false },
    { id: 'c_description', label: 'Description', alignRight: false },
];


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1000,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
    maxHeight: '100vh',
    overflow: 'scroll',
};

export default function LatestNews(props) {
    const dispatch = useDispatch()
    const [state, setState] = useState()
    const [InputImagestate, setInputImageState] = useState({
        image: null,
        icon: null,
    })
    const [PopUpstate, setPopUpstate] = useState({})
    const [open, setopen] = useState("")

    const handleClose = () => {
        setopen(false)
        setInputImageState({})
    }
    const handleOpen = () => { setopen(true) }
    const [Error, setError] = useState("")
    const [updateModelopen, setupdateModelopen] = useState("")

    const handleUpdateModelClose = () => {
        setInputImageState({})
        setPopUpstate()
        setupdateModelopen(false)
    }

    const handleUpdateModelOpen = () => { setupdateModelopen(true) }

    const UpdatePopUpSubmitData = async (e) => {
        setPopUpstate({})
        setInputImageState("")
        let formData = new FormData();
        formData.append("id", PopUpstate.id);
        formData.append("description", PopUpstate.description);
        formData.append("image", PopUpstate.image);
        formData.append("alt_tag", PopUpstate.alt_tag);
        formData.append("head_line", PopUpstate.head_line);
        setupdateModelopen(false)
        await axios
            .post(`${baseUrlPostGres()}/api/letest-news-update`, formData, {
                headers: apiHeader()
            })
            .then(response => {
                if (response.data.message === "Unauthorized please login again!") {
                    dispatch(LogoutAction(response.data.message))
                }
                listCalling()
                toast("Content Added successfully")

            })
            .catch(errors => {
                console.log("user list error", errors);
            })
    }

    const openhandleUpdateModel = (ele) => {
        setPopUpstate(ele)
        handleUpdateModelOpen(true)
    }

    useEffect(() => {
        listCalling()
    }, [])

    const listCalling = () => {
        axios
            .get(`${baseUrlPostGres()}/api/list_news`, {
                headers: apiHeader()
            })
            .then(response => {
                if (response.data.message === "Unauthorized please login again!") {
                    dispatch(LogoutAction(response.data.message))
                }
                console.log("GetUpcomingMatchListAction Response is", response)
                setState(response.data.success)
            })
            .catch(errors => {
                console.log("user list error", errors);
            })
    }

    function getBase64(file, name) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(setInputImageState({ ...InputImagestate, [name]: reader.result }));
            reader.onerror = error => reject(error);
        });
    }

    const handleChange = (e) => {
        if (e.target) {
            var { name, value } = e.target;
            if (name === "image" || name === "icon") {
                var file = e.target.files[0];
                setPopUpstate({ ...PopUpstate, [name]: file });
                getBase64(file, name);
            } else {
                setPopUpstate({ ...PopUpstate, [name]: value });
            }
        } else {
            setPopUpstate((prevState) => ({
                ...prevState,
                "description": e,
            }));
        }
    }


    const ADDPopUpSubmitData = async () => {
        if (PopUpstate?.description && PopUpstate?.image && PopUpstate?.head_line && PopUpstate?.alt_tag) {
            let formData = new FormData();
            setError("")
            setPopUpstate({})
            setInputImageState("")
            formData.append("description", PopUpstate.description);
            formData.append("image", PopUpstate.image);
            formData.append("alt_tag", PopUpstate.alt_tag);
            formData.append("head_line", PopUpstate.head_line);
            setopen(false)
            await axios
                .post(`${baseUrlPostGres()}/api/letest-add-news`, formData, {
                    headers: apiHeader()
                })
                .then(response => {
                    if (response.data.message === "Unauthorized please login again!") {
                        dispatch(LogoutAction(response.data.message))
                    }
                    listCalling()
                    toast("Content Added successfully")

                })
                .catch(errors => {
                    console.log("user list error", errors);
                })
        } else {
            setError("All fields are required*")
        }

    }

    const openhandleDeleteModel = async (ele) => {
        let formData = new FormData();
        formData.append("description", ele.id);
        setopen(false)
        await axios.delete(`${baseUrlPostGres()}/api/letest-news-delete/${ele.id}`, {
            headers: apiHeader()
        })
            .then(response => {
                if (response.data.message === "Unauthorized please login again!") {
                    dispatch(LogoutAction(response.data.message))
                }
                listCalling()
                toast("content deleted successfully")

            })
            .catch(errors => {
                console.log("user list error", errors);
            })
    }

    const modules = {
        toolbar: [
            [{ header: [1, 2, false] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
            ['link'],
            ['clean']
        ]
    };
    const formats = ['header', 'bold', 'italic', 'underline', 'strike', 'blockquote', 'list', 'bullet', 'indent', 'link', 'image'];

    return (
        <>
            <Page title="User">
                <Container maxWidth="lg">
                    <Box sx={{ flexGrow: 1 }}>
                        <Grid container spacing={2}>
                            <Grid xs={12} item style={{ display: "flex", justifyContent: "space-between" }}>
                                <HeaderBreadcrumbs
                                    heading='News'
                                    links={[
                                        { name: 'Dashboard', href: "/dashboard" },
                                        { name: 'Latest News' }
                                    ]}
                                />
                                <Button variant="contained" style={{ margin: "50px" }} onClick={handleOpen}>Add News</Button>
                            </Grid>
                        </Grid>
                    </Box>
                    <Scrollbar>
                        <TableContainer sx={{ minWidth: 800 }}>
                            <Table>
                                <UserListHead
                                    headLabel={TABLE_HEAD}
                                />
                                {state &&
                                    state.map((ele, i) => {
                                        return (
                                            <TableBody key={i}>
                                                <TableRow
                                                >
                                                    <TableCell component="th" scope="row">{i + 1}</TableCell>
                                                    <TableCell component="th" scope="row" >  <TextField
                                                        value={ele.head_line}
                                                        name="page_name"
                                                        style={{ width: "100%" }}
                                                        onChange={handleChange}
                                                        disabled
                                                    /></TableCell>
                                                    <TableCell component="th" scope="row">
                                                        <div dangerouslySetInnerHTML={{ __html: ele.description }}
                                                            style={{
                                                                "overflow": "hidden",
                                                                "textOverflow": "ellipsis",
                                                                "display": "-webkit-box",
                                                                "WebkitLineClamp": "2",
                                                                "lineClamp": "2",
                                                                "WebkitBoxOrient": "vertical",
                                                                "maxWidth": "600px"
                                                            }}
                                                        />
                                                    </TableCell>
                                                    <TableCell component="th" scope="row" >  <TextField
                                                        value={ele.alt_tag}
                                                        name="alt_tag"
                                                        style={{ width: "100%" }}
                                                        onChange={handleChange}
                                                        disabled
                                                    /></TableCell>
                                                    <TableCell component="th" scope="row" >
                                                        <Button variant="contained" color="success" onClick={() => openhandleUpdateModel(ele)}><Edit /></Button>
                                                        <Button variant="contained" color="error" onClick={() => openhandleDeleteModel(ele)} > <Delete /></Button>
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        )
                                    })}
                            </Table>

                        </TableContainer>
                    </Scrollbar>
                </Container>
            </Page>

            <Modal
                open={open}
                onClose={handleClose}
            >
                <Box sx={style}>
                    <Container maxWidth="lg">
                        <Scrollbar>
                            <TableContainer sx={{ minWidth: 800 }}>
                                <Table>
                                    <UserListHead
                                        headLabel={POPUP_TABLE_HEAD}
                                    />
                                    {state &&
                                        <TableBody>
                                            <TableRow
                                            >
                                                <TableCell component="th" scope="row">1</TableCell>
                                                <TableCell component="th" scope="row" > Banner Image</TableCell>
                                                <TableCell component="th" scope="row" >
                                                    <TextField type="file"
                                                        accept="video/*"
                                                        name="image"
                                                        onChange={handleChange}
                                                        style={{ width: "100%" }}
                                                        sx={{
                                                            ".MuiOutlinedInput-root": {
                                                                paddingTop: "1rem",
                                                                flexDirection: "column"
                                                            },
                                                            img: {
                                                                paddingRight: "1rem",
                                                                height: "100px"
                                                            }
                                                        }}
                                                        InputProps={{
                                                            startAdornment: <img alt="" src={InputImagestate.image != null && InputImagestate.image} />
                                                        }}
                                                    /></TableCell>
                                            </TableRow>

                                            <TableRow
                                            >
                                                <TableCell component="th" scope="row">2</TableCell>
                                                <TableCell component="th" scope="row" > Alt Tag</TableCell>
                                                <TableCell component="th" scope="row" >  <TextField
                                                    value={state.alt_tag}
                                                    name="alt_tag"
                                                    style={{ width: "100%" }}
                                                    onChange={handleChange}
                                                /></TableCell>
                                            </TableRow>

                                            <TableRow
                                            >
                                                <TableCell component="th" scope="row">3</TableCell>
                                                <TableCell component="th" scope="row" > Title</TableCell>
                                                <TableCell component="th" scope="row" >  <TextField
                                                    value={state.head_line}
                                                    name="head_line"
                                                    style={{ width: "100%" }}
                                                    onChange={handleChange}
                                                /></TableCell>
                                            </TableRow>
                                            <TableRow
                                            >
                                                <TableCell component="th" scope="row">4</TableCell>
                                                <TableCell component="th" scope="row" > Description</TableCell>
                                                <TableCell component="th" scope="row" >
                                                    <ReactQuill
                                                        className='quill-editor-container'
                                                        name="description"
                                                        modules={modules}
                                                        formats={formats}
                                                        onChange={handleChange}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                            <TableRow
                                            >
                                                <TableCell component="th" scope="row">{Error}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    }
                                </Table>

                            </TableContainer>
                        </Scrollbar>
                        <Button variant="contained" style={{ margin: "20px" }} onClick={ADDPopUpSubmitData}>Submit</Button>
                        <Button variant="contained" style={{ margin: "20px" }} onClick={handleClose}>Cancel</Button>
                    </Container>
                </Box>
            </Modal>

            <Modal
                open={updateModelopen}
                onClose={handleUpdateModelClose}
            >
                <Box sx={style}>
                    <Container maxWidth="lg">
                        <Scrollbar>
                            <TableContainer sx={{ minWidth: 800 }}>
                                <Table>
                                    <UserListHead
                                        headLabel={POPUP_TABLE_HEAD}
                                    />
                                    {PopUpstate &&
                                        <TableBody>
                                            <TableRow
                                            >
                                                <TableCell component="th" scope="row">1</TableCell>
                                                <TableCell component="th" scope="row" > Banner Image</TableCell>
                                                <TableCell component="th" scope="row" >  <TextField type="file"
                                                    accept="video/*"
                                                    name="image"
                                                    onChange={handleChange}
                                                    style={{ width: "100%" }}
                                                    sx={{
                                                        ".MuiOutlinedInput-root": {
                                                            paddingTop: "1rem",
                                                            flexDirection: "column"
                                                        },
                                                        img: {
                                                            paddingRight: "1rem",
                                                            height: "100px"
                                                        }
                                                    }}
                                                    InputProps={{
                                                        startAdornment: <img alt="" src={InputImagestate.image != null
                                                            ? InputImagestate.image :
                                                            `${baseUrlPostGres()}/${PopUpstate.image}`} />
                                                    }}
                                                /></TableCell>
                                            </TableRow>

                                            <TableRow
                                            >
                                                <TableCell component="th" scope="row">2</TableCell>
                                                <TableCell component="th" scope="row" > Alt Tag </TableCell>
                                                <TableCell component="th" scope="row" >  <TextField
                                                    value={PopUpstate.alt_tag}
                                                    name="alt_tag"
                                                    style={{ width: "100%" }}
                                                    onChange={handleChange}
                                                /></TableCell>
                                            </TableRow>

                                            <TableRow
                                            >
                                                <TableCell component="th" scope="row">3</TableCell>
                                                <TableCell component="th" scope="row" > Title</TableCell>
                                                <TableCell component="th" scope="row" >
                                                    <TextField
                                                        value={PopUpstate.head_line}
                                                        name="head_line"
                                                        style={{ width: "100%" }}
                                                        onChange={handleChange}
                                                    />
                                                </TableCell>
                                            </TableRow>

                                            <TableRow
                                            >
                                                <TableCell component="th" scope="row">4</TableCell>
                                                <TableCell component="th" scope="row" > Description</TableCell>
                                                <TableCell component="th" scope="row" >
                                                    <ReactQuill
                                                        className='quill-editor-container'
                                                        name="description"
                                                        modules={modules}
                                                        formats={formats}
                                                        value={PopUpstate?.description}
                                                        onChange={handleChange}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    }
                                </Table>
                            </TableContainer>
                        </Scrollbar>
                        <Button variant="contained" style={{ margin: "20px" }} onClick={UpdatePopUpSubmitData}>Submit</Button>
                        <Button variant="contained" style={{ margin: "20px" }} onClick={handleUpdateModelClose}>Cancel</Button>
                    </Container>
                </Box>
            </Modal>
        </>
    );
}
